module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-up-left-b4f0f70b55d5d36c18fac3d96e39a6ec.svg";